import base from "../../../base";

const isProd = process.env.NODE_ENV === "production";

const createManagementSessionFunctionURL = isProd
	? "https://us-central1-aadojo-8bbac.cloudfunctions.net/createmanagementsession"
	: "http://127.0.0.1:5001/test-preflopmastery/us-central1/createmanagementsession";

export default async function openStripeManagementSession(uid) {
	const stripeCustomerID = await base.fetch(`users/${uid}/stripeCustomerID`, { context: {} });
	if (!stripeCustomerID) {
		throw new Error("No Stripe customer found");
	}

	const result = await fetch(createManagementSessionFunctionURL, {
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
		},
		method: "POST",
		body: JSON.stringify({ stripeCustomerID }),
	});
	const data = await result.json();

	if (data.url) {
		window.location.href = data.url;
		return;
	}

	throw new Error("No management URL returned");
}
